<template>
    <div class="col-sm-12">
        <div class="data-list-item add" @click.stop="$emit('add')">
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
                <font-awesome-icon icon="hands-helping" class="card-body-icon" />
            </div>
        </div>
        <div class="col-12 nopads my-2 list-container">
            <Transition name="fade">
                <div v-if="results.length > 0" class="col-sm-12 list-content result-table">
                    <vue3-datatable
                        ref="resultTable"
                        :rows="results"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="100%"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                    >
                        <template #customer="row">
                            {{ row.value.customer.name }}
                        </template>
                        <template #contractor="row">
                            {{ row.value.contractor.name }}
                        </template>
                        <template #remove="row">
                            <div class="col-12 nopads text-center">
                                <font-awesome-icon
                                    :id="row.value.customer.id + '_' + row.value.contractor.id"
                                    :title="$t('common.remove')"
                                    icon="trash"
                                    class="ml-1 mr-1 mt-1 pointer"
                                    style="color:#9e0c0c;"
                                    @click="deleteRelationship(row.value)"
                                />
                            </div>
                        </template>
                    </vue3-datatable>
                </div>
            </Transition>
        </div>
    </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
import { workManagementHelper } from '../../mixins/WorkManagementMixin';
import { restApi } from '../../mixins/RestApiMixin';
import { inject } from "vue";

export default {
    name: 'CompanyRelationshipList',
    components: { Vue3Datatable },
    mixins: [workManagementHelper, restApi],
    props: {
        results: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            loading: false,
            fields: [
                { field: 'customer.name', title: this.$t('relationships.customer'), sort: true, headerClass: 'routa-table-header' },
                { field: 'contractor.name', title: this.$t('relationships.main_contractor'), sort: true, headerClass: 'routa-table-header' },
                { field: 'remove', title: '', sort: false, headerClass: 'routa-table-header' }
            ]
        };
    },
    setup() {
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    methods: {
        deleteRelationship(relationship) {
            if (relationship) {
                var url = this.companyRelationshipUrl + '?customer=' + relationship.customer.id + '&contractor=' + relationship.contractor.id;
                this.restDelete(url, this.success, this.fail);
            }
        },

        success() {
            this.loading = true;
            this.$emit('update');
        },

        fail() {
            this.showAlert(this.$t('common.alert_update_failed'));
            this.loading = false;
        }
    }
};
</script>
